module.exports = __webpack_public_path__ + "static/media/3-3.d4d8b138.svg";